'use client';

const VALUES = [
  { label: 'Cuir Pleine Fleur', sub: 'Tanné végétal' },
  { label: 'Couture Sellier', sub: 'À la main' },
  { label: 'Numérotée', sub: 'Édition limitée' },
  { label: 'Patine Naturelle', sub: 'Cire d\'abeille' },
  { label: 'Garantie à Vie', sub: 'Réparation atelier' },
];

export default function ValuesStrip() {
  return (
    <div className="relative bg-[#0a0a0f] border-y border-[#D4AF37]/15 py-5 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-wrap items-center justify-center gap-x-10 gap-y-3">
        {VALUES.map((v, i) => (
          <div key={v.label} className="flex items-center gap-3">
            <div className="flex flex-col items-center sm:items-start">
              <span className="text-xs sm:text-sm uppercase tracking-[0.2em] text-[#F4E8C1] font-medium">
                {v.label}
              </span>
              <span className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]/70 mt-0.5">
                {v.sub}
              </span>
            </div>
            {i < VALUES.length - 1 && (
              <span className="text-[#D4AF37]/40 text-lg hidden sm:inline">·</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
